/* eslint-disable import/no-mutable-exports -- DI providers are assigned via setters after setupStore */
export let localAsyncStorage = {};
export let cookiesJar;
export let authProvider;
export let reduxDispatch;
export function setAuthProvider(authProviderInstance) {
    authProvider = authProviderInstance;
}
export function setCookiesJar(cookiesReader) {
    cookiesJar = cookiesReader;
}
export function setLocalAsyncStorage(localStorageInstance) {
    localAsyncStorage = localStorageInstance;
}
export function setReduxDispatch(dispatch) {
    reduxDispatch = dispatch;
}
